import {Button} from '@/components/atoms';
import {AuthContext} from '@/context/Auth/AuthContext';
import {useContext} from 'react';
import {useIntl} from 'react-intl';

export const Logout = () => {
  const {signOut} = useContext(AuthContext);
  const {formatMessage} = useIntl();

  const onClickLogout = () => {
    signOut();
  };

  return (
    <div className='flex justify-end'>
      <Button data-testid='btn-logout' handleButton={onClickLogout}>
        {formatMessage({id: 'LOGOUT.LOGOUT_BUTTON'})}
      </Button>
    </div>
  );
};
